import type MarkdownIt from 'markdown-it';

/** Recognize the currency dollar before an inline math rule can consume it.
 * Inline parsing leaves fenced/inline code, link destinations and math bodies
 * to their own rules; no rewriting of the authored Markdown is necessary.
 */
export function currencyPlugin(markdown: MarkdownIt) {
  markdown.inline.ruler.before('text', 'brl_currency', (state, silent) => {
    if (state.src[state.pos] !== '$' || state.src[state.pos - 1] !== 'R' || state.src[state.pos + 1] === '$') {
      return false;
    }
    if (!silent) state.pending += '$';
    state.pos += 1;
    return true;
  });
}
